import { useEffect, useState } from 'react'
import { videoStates, audioStates } from '../spotStateConstants'
const spotPantSound = require('../../../../assets/sounds/dances/SFX_pupping_panting_louder.mp3')
const spotBarkSound = require('../../../../assets/sounds/dances/SFX_cartoon-happy-puppy-bark_v2.mp3')

export default function useSpot(speech, initialSpotState){

    const [ spotState, setSpotState ] = useState(initialSpotState)

    useEffect(() => {
        if(!speech){
            console.warn("Spot's audio will not work properly without app speech. Please pass the speech object into the props.")
        }
    }, [])

    const disappear = () => {
        setSpotState(videoStates.invisible)
    }
    const goSleep = () => {
        setSpotState(videoStates.sleeping)
    }
    const wakeUpFromSleep = async () => {
        setSpotState(videoStates.wokeUpFromSleep)
        await speech.playAppSoundsWithPromise({
            url: spotPantSound,
            key: audioStates.panting,
        });
        setSpotState(videoStates.awake)
    }
    const wakeUp = () => {
        setSpotState(videoStates.awake)
    }
    const bark = async () => {
        await speech.playAppSoundsWithPromise({
            url: spotBarkSound,
            key: audioStates.bark
        })
    }

    return {
        disappear,
        goSleep,
        wakeUpFromSleep,
        wakeUp,
        bark,
        spotState,
        spotStates: videoStates,
        assets: {
            bark: {
                url: spotBarkSound,
                key: audioStates.bark
            }
        }
    }
}